import { DOCUMENTS_URL } from 'lib/_api-helpers';

type VideoPlayerProps = {
    filepath: string;
};

export default function VideoPlayer({ filepath }: VideoPlayerProps): JSX.Element {
    return <video controls controlsList="nodownload" src={`${DOCUMENTS_URL}/${filepath}`} width="100%" />;
}
